import React, { useEffect, useState } from 'react';
import "./RawMaterials.css";

function RawMaterials () {
    let [ mobile, setMobile ] = useState( false );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='about-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/quality/banner.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/quality/banner-mobile.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Join Us</span>
                    <span>We provide high-quality materials essential for the aerospace industry's manufacturing and maintenance needs.</span>
                </div>
            </div>
            <div className='about-header'>
                Empowering Innovation, Crafting Excellence
            </div>
            <div className='about-content'>
                At Aero Fasteners Pvt. Ltd., we are pioneers in providing aerospace-grade fasteners that ensure the highest standards of safety and performance. Our success is driven by our dedicated team of professionals who are passionate about aerospace technology and committed to excellence. We are always on the lookout for talented individuals who share our vision and values.
            </div>
            <div className='about-middle'>
                <img src={require("../../images/why_choose_us/image.avif")} alt="quality-middle" height={"100%"} width={"100%"} />
                <div className='about-middle-content'>
                    <div style={{ marginBottom: '1rem' }} className='about-content-header'>Why Aero Fasteners Pvt. Ltd.?-</div>
                    <ul>
                        <li><b>Cutting-Edge Projects:</b> Work on innovative projects that push the boundaries of aerospace technology.</li>
                        <li><b>Career Growth:</b> We offer numerous opportunities for professional development and career advancement.</li>
                        <li><b>Dynamic Work Environment:</b> Be part of a collaborative and forward-thinking team that values your contributions.</li>
                    </ul>
                </div>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>What We Offer</div>
                <ul>
                    <li><b>Competitive Salary:</b> Attractive remuneration packages based on experience and qualifications.</li>
                    <li><b>Comprehensive Benefits:</b> Health insurance, retirement plans, and other employee benefits.</li>
                    <li><b>Work-Life Balance:</b> Flexible working hours and a supportive work environment to help you achieve a balance between personal and professional life.</li>
                </ul>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Our Recruitment Process</div>
                <ol>
                    <li><b>Application Review:</b> Submit your resume and cover letter detailing your qualifications and interest in the position.</li>
                    <li><b>Interview:</b> If your profile matches our requirements, we will invite you for an interview to discuss your skills and experiences.</li>
                    <li><b>Assessment:</b> Depending on the role, you may be asked to complete a technical assessment or practical test.</li>
                    <li><b>Offer:</b> Successful candidates will receive an offer letter outlining the terms of employment.</li>
                </ol>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>How to Apply</div>
                <span>Ready to take the next step in your career? We’d love to hear from you!!</span>
                <ul>
                    <li>Email Your Resume: [<a href="mailto:tinku@aerofplcom" style={{ color: "black" }}>tinku@aerofplcom</a>]</li>
                </ul>
            </div>
        </div>
    )
}

export default RawMaterials
